import { useCallback, useEffect, useRef } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { addWatermarkToImage } from '@vt/apis/lib-ex/v2/givrali'
import { getWaterMarkDefsItemInfo } from '@ow/utils'
import { checkIsImage } from '@ow/ditto-core'

const transformCode = (waterMarkInfo) => {
  try {
    return btoa(
      unescape(
        encodeURIComponent(
          `["${waterMarkInfo[0] || ''}","${waterMarkInfo[1] || ''}","${
            waterMarkInfo[2] || ''
          }"]`
        )
      )
    )
  } catch (e) {
    return ''
  }
}
const useBeforeTransform = function () {
  const { showRecycle, exporterConfig } = useTbViewStore((state) =>
    pick(state, ['showRecycle', 'exporterConfig'])
  )

  const { waterMarkDefs } = exporterConfig || {}

  const showRecycleRef = useRef(showRecycle)

  useEffect(() => {
    showRecycleRef.current = showRecycle
  }, [showRecycle])

  const beforeTransform = useCallback(
    (value, defs, rowData) => {
      if (defs && defs.type === 'operate') {
        return {
          value,
          rowData,
          defs,
          showRecycle: showRecycleRef.current,
        }
      }
      // 在hooks里面处理应该不是一个好的方案。。。
      if (defs && defs.type === 'media') {
        const arrs = (value || []).map((item) => {
          const url = item.src || item.link
          if (!url) {
            return item
          }
          let src = url
          const position = url && url.indexOf('?Expires=') // 对非表单新建的数据特殊处理
          if (
            url &&
            (url.indexOf('ow-prod.oss-') > -1 ||
              url.indexOf('ow-prod-cdn') > -1)
          ) {
            src = `${
              position === -1 ? url : url.slice(0, position)
            }?x-oss-process=image/resize,h_170,m_lfit`
          }
          const isImage = checkIsImage(item)
          const { extInfo } = item
          const finalData = { ...rowData, extInfo }

          //
          const waterMarkInfoFieldMap = {
            checkPicture: waterMarkDefs,
            modifyPicture: [
              {
                slug: 'modifyLnglat_text',
                type: 'dataField',
              },
              {
                slug: 'modifyAt',
                type: 'dataField',
                fieldType: 'date',
              },
              {
                slug: 'modifyLnglat',
                type: 'dataField',
              },
            ],
            reviewPicture: [
              {
                slug: 'reviewLnglat_text',
                type: 'dataField',
              },
              {
                slug: 'reviewAt',
                type: 'dataField',
                fieldType: 'date',
              },
              {
                slug: 'reviewLnglat',
                type: 'dataField',
              },
            ],
          }
          let currentFieldWaterMarkInfo = waterMarkDefs
          if (waterMarkInfoFieldMap[defs.slug]) {
            currentFieldWaterMarkInfo = waterMarkInfoFieldMap[defs.slug]
          }
          const waterMarkInfo = getWaterMarkDefsItemInfo(
            currentFieldWaterMarkInfo,
            finalData
          )
          //

          const endPosition = url.indexOf('?Expires=')
          const link = item.src || item.link
          return {
            ...item,
            waterMarkInfo:
              waterMarkInfo && waterMarkInfo.length ? waterMarkInfo : null,
            srcWatermark:
              typeof btoa !== 'undefined' &&
              isImage &&
              waterMarkInfo &&
              waterMarkInfo.length > 0
                ? addWatermarkToImage(
                    encodeURIComponent(
                      endPosition === -1 ? link : link.slice(0, endPosition)
                    ),
                    encodeURIComponent(transformCode(waterMarkInfo)),
                    10,
                    'white',
                    0,
                    true
                  )
                : src,
          }
        })
        return arrs
      }
      return value
    },
    [showRecycle]
  )

  return beforeTransform
}

export default useBeforeTransform
